
import $ from 'jquery';
import { validateEmail } from "./dataHelpers";
import { SCENE_EVENTS } from './Model';

const contributoreHelper = (data) => `
<div class="contributore-flex-container">
  <div class="contributore-flex-items">
    <span>${data.email}</span>
  </div>
  <div class="contributore-flex-items">
      <div class="contributore-round-wrapper contributore-add-as-owner">
    </div>
  </div>
  <div class="contributore-flex-items">
    <span class="material-icons-outlined md-18 box_check clickable contributores-info">more_horiz</span>
  </div>
  <div class="contributores-dropdown">
      <div class="remove_from_contributores delete_contributore">Remove from contributors</div>
      <div class="add_as_owner contributore-add-as-owner">Add as owner</div>   
  </div>
</div>
`;
class ContributeHelper {

  constructor({ model }) {
    this.model = model;
    this.items = [];
    this.container = $(document).find("#world_contributores_list");
    this.contributores = null;
    this.appUsers = null;
    this.filtered = [];
    this.dropdowns = [];
    this.modal = $(".modal.contributore_and_owner_holder");

    const onUsersLoaded = () => {
      this.model.worldFetcher.getContributores(this.model.URLS.ID, onContributores, onContributores);
    }

    const onClickedItem = (item, input) => {
      console.log(item, input)
      this.container.hide();
      const worldId = this.model.URLS.ID;
      this.model.worldFetcher.removeContributore(item.id, worldId, onUsersLoaded, onUsersLoaded)
    }

    this.onDropdownClick = (e) => {
      if ($(e.target).is(".contributores-dropdown") || $(e.target).is(".contributores-dropdown div") || $(e.target).is(".contributores-info")) {
        return
      }
      this.dropdowns.forEach(item => {
        item.hide();
        item.removeClass("active");
      })
    }
    $(document.body).on("click", this.onDropdownClick)


    const onUsers = (response) => {
      // model.appUsers = response;
      // this.filtered = [{ "id": "2", "email": "a.haaken@aptis.info" }, { "id": "54", "email": "adityat1993@gmail.com" }, { "id": "58", "email": "ajaykantkanojiya@gmail.com" }, { "id": "76", "email": "alexandru.marincas@alten.com" }, { "id": "78", "email": "ana.duspara@speck.agency" }, { "id": "85", "email": "ana@inorbit.hr" }, { "id": "66", "email": "anana.duspara@gmail.com" }, { "id": "81", "email": "anana@test.com" }, { "id": "82", "email": "anatest4@ana.com" }, { "id": "80", "email": "anatester@ana.com" }, { "id": "75", "email": "bojan.ratkovic@speck.agency" }, { "id": "86", "email": "eduardo.maric@speck.agency" }, { "id": "5", "email": "fuldner@a-t.de" }, { "id": "52", "email": "gunjan.shahane@gmail.com" }, { "id": "51", "email": "gunjan.shahane@mindcrewtech.com" }, { "id": "6", "email": "info@albanese-music.de" }, { "id": "77", "email": "info@inorbit.hr" }, { "id": "84", "email": "inorbit.doo@gmail.com" }, { "id": "50", "email": "maroofahmed.siddique@mindcrewtech.com" }, { "id": "53", "email": "maroofahmedsiddique@gmail.com" }, { "id": "57", "email": "mindcrew.technologies@gmail.com" }, { "id": "83", "email": "minomaximus@gmail.com" }, { "id": "65", "email": "nahar321@gmail.com" }, { "id": "88", "email": "nikola.krtalic@speck.agency" }, { "id": "55", "email": "prakhar.kp@gmail.com" }, { "id": "11", "email": "raihanrobi17@gmail.com" }, { "id": "1", "email": "s.stamprath@aptis.info" }, { "id": "9", "email": "s.stamprath+2222@aptis.info" }, { "id": "59", "email": "s.stamprath+bagless@aptis.info" }, { "id": "49", "email": "s.stamprath+end@aptis.info" }, { "id": "10", "email": "saenger@a-t.de" }, { "id": "13", "email": "sunwarrior3206@gmail.com" }, { "id": "18", "email": "test@test.bd" }, { "id": "17", "email": "test@test.com" }, { "id": "12", "email": "test@test.se" }, { "id": "22", "email": "test@test.sebd" }, { "id": "19", "email": "test@test.see" }, { "id": "14", "email": "test@test.seeee" }, { "id": "16", "email": "test@test.seeeee" }, { "id": "15", "email": "test@test.seeeeeee" }, { "id": "21", "email": "test@test.seeeeeeeeeeee" }, { "id": "64", "email": "test24396113@wintds.org" }, { "id": "62", "email": "test29944161@wintds.org" }, { "id": "79", "email": "test3@test.com" }, { "id": "63", "email": "test38546189@wintds.org" }, { "id": "60", "email": "test46522757@wintds.org" }, { "id": "61", "email": "test7084707@wintds.org" }]
      if (!this.filtered) {
        return
      }
      $(document).find("#world_contributores_list").empty();
      this.items.forEach(item => {
        item.off("click");
        item.children().off();
      })
      this.items = [];
      this.filtered.map(item => {
        const label = $(contributoreHelper(item));
        const input = label.find(".delete_contributore");
        const addAsOwner = label.find(".add_as_owner");
        const isOwnerWrapper = label.find(".contributore-round-wrapper");

        const dropdown = label.find(".contributores-dropdown");
        this.dropdown = dropdown;
        const dropdownToggle = label.find(".contributores-info");
        dropdownToggle.on("click", () => {
          if (dropdown.hasClass("active")) {
            dropdown.removeClass("active");
            dropdown.hide();
          } else {
            dropdown.addClass("active");
            dropdown.show();
          }
        });

        input.on("click", (e) => {
          onClickedItem(item, input)
        })

        if (Number(this.model.creator) === Number(item.id)) {
          isOwnerWrapper.append($(`    
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" fill="#6B9D11" stroke="white" stroke-width="2"/>
            <path d="M24 17.9C25.16 17.9 26.1 18.84 26.1 20C26.1 21.16 25.16 22.1 24 22.1C22.84 22.1 21.9 21.16 21.9 20C21.9 18.84 22.84 17.9 24 17.9ZM24 26.9C26.97 26.9 30.1 28.36 30.1 29V30.1H17.9V29C17.9 28.36 21.03 26.9 24 26.9ZM24 16C21.79 16 20 17.79 20 20C20 22.21 21.79 24 24 24C26.21 24 28 22.21 28 20C28 17.79 26.21 16 24 16ZM24 25C21.33 25 16 26.34 16 29V32H32V29C32 26.34 26.67 25 24 25Z" fill="white"/>
          </svg>
          `))
          input.parent().empty();
          dropdownToggle.off("click");
          dropdownToggle.css("opacity", "50%");
          dropdownToggle.removeClass("clickable");

        }

        this.items.push(label);


        this.dropdowns.push(dropdown)
        addAsOwner.on("click", (e) => {
          if (item.email === this.model.config.email) {
            this.model.alert('error', $trans('error-you-cannot-add-yourself-as-owner'));
            return;
          }
          dropdown.removeClass("active");
          dropdown.hide();
          this.model.confirm(`${$trans('confirm-add-as-owner-1')} ${item.email} ${$trans('confirm-add-as-owner-2')}`, () => {
            const worldId = this.model.URLS.ID;
            this.model.worldFetcher.addOwner(item.email, worldId, onAddNewOwnerCallback, onAddNewOwnerCallback)
          });
        })

        $(document).find("#world_contributores_list").append(label)


      })
    };
    onUsers();

    const onContributores = (response) => {
      this.container.show();
      if (!Array.isArray(response)) {
        return;
      }
      this.filtered = response;
      this.filtered = this.filtered.filter((item, index, self) =>
        index === self.findIndex((t) => t.email === item.email)
      );

      onUsers();
    }
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {

    } else {

      this.model.worldFetcher.getContributores(this.model.URLS.ID, onContributores, onContributores);
    }

    const onFindCallback = (response) => {
      this.container.show();
      $("#contributore_email").val("");
      if (response.success === true) {
        this.model.worldFetcher.getContributores(this.model.URLS.ID, onContributores, onContributores);
        this.model.dispatchEvent({ type: SCENE_EVENTS.SCENE_EDIT_DATA_CHANGED });
        this.model.info('success', $trans('success-contributore'));
      }
      else {
        this.model.alert('error', $trans('error-user-dont-exist'));
      }
    }

    $("#edit_contributore").on("click", () => {
      this.modal.addClass("is-active");
      this.modal.show();
      return;
    });
    $("#add_contributore").on("click", () => {
      const email = $("#contributore_email").val();
      if (email === this.model.config.email) {
        this.model.alert('error', $trans('you-are-already-contributor'));
        return;
      }

      this.container.hide();
      if (!validateEmail(email)) {
        this.model.alert('error', $trans('error-invalid-email'));
        this.container.show();
        return;
      }
      const emailExists = this.filtered && this.filtered.filter(user => user.email === email)[0]
      if (emailExists) {
        this.model.alert('error', `Duplicate entry`);
        this.container.show();
        return;
      }
      const worldId = this.model.URLS.ID;
      this.model.worldFetcher.findUserByEmail(email, worldId, onFindCallback, onFindCallback)
    });


    const onAddNewOwnerCallback = (response) => {
      if (response.success === true) {
        this.model.info('success', $trans('success-added-as-owner'))
        location.reload()
      }
      if ((response && response.response && response.response.data.success) === true) {
        this.model.info('success', $trans('success-added-as-owner'))
        location.reload()
      }
      else {
        this.model.alert('error', response.message)
      }
    }

    // $("#add_world_owner").on("click", () => {
    //   this.container.hide();
    //   const email = $("#change_world_owner").val();
    //   if (!validateEmail(email)) {
    //     this.model.alert('error', $trans('error-invalid-email'));
    //     return;
    //   }
    //   const worldId = this.model.URLS.ID;
    //   this.model.worldFetcher.addOwner(email, worldId, onAddNewOwnerCallback, onAddNewOwnerCallback)
    // });


  }

}

export { ContributeHelper }
